
import { createContext, useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoginLayout from "layouts/login"
import StoreSettingService from "services/store_setting";
import AppLoader from "components/app-loader";
const service = new StoreSettingService();

const WorkspaceContext = createContext();

function WorkspaceProvider({ children }) {


    const [workspace, setWorkSpace] = useState({ collaboratorSetting: {} });


    useEffect(() => {
        loadData();

    }, [])

    const loadData = async () => {
        var setting = await service.getCollaboratorSetting();
        setWorkSpace({ ...workspace, collaboratorSetting: setting })
    }






    return <WorkspaceContext.Provider value={{ workspace }}>
        {children}

    </WorkspaceContext.Provider>;

}

const useWorkSpace = () => {
    const context = useContext(WorkspaceContext);
    return context;
};

export { useWorkSpace };
export default WorkspaceProvider;
